import { render, staticRenderFns } from "./activeInfo.vue?vue&type=template&id=5647178b&scoped=true"
import script from "./activeInfo.vue?vue&type=script&lang=js"
export * from "./activeInfo.vue?vue&type=script&lang=js"
import style0 from "./activeInfo.vue?vue&type=style&index=0&id=5647178b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5647178b",
  null
  
)

export default component.exports